import { PageWrapper } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { Hero } from '@/components/transparency/Hero';
import { Posts } from '@/components/transparency/Posts';
import { Share } from '@/components/transparency/Share';
import { useShowHeaderCtaOnScroll } from '@/hooks/useShowHeaderCtaOnScroll';
import { config } from '@/pageConfig/transparency/us/en';

export default function TransparencyPage() {
  useShowHeaderCtaOnScroll(true);

  return (
    <>
      <SEO {...config.seo} />
      <Layout pt={[40, 70]} pb={[40, 70]} headerActions={config.layout.headerActions}>
        <PageWrapper px="20px">
          <Hero {...config.hero} />
          <Posts />
          <Share />
        </PageWrapper>
      </Layout>
    </>
  );
}
